import { IStores } from ".";

export class StoreConstructor {
  public stores: IStores;

  constructor(stores: IStores) {
    this.stores = stores;
  }
}
